import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import DropDownListProps from './DropDownListProps'

import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: DropDownListProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el

        kendo.jQuery(widgetElement).kendoDropDownList(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            if(that.v3){
                that.$emit('update:modelValue', widgetElement.value)
            } else {
                that.$emit('changemodel', widgetElement.value)
            }
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoDropDownList()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/KendoDropDownListMixin.js